// UI permission buckets for granular (member-tier) workspace access. Mirrors the
// backend WORKSPACE_PERMISSION_PRESETS keys in rbac/role-actions.ts — the server
// expands + sanitizes these into concrete actions, so this list is display-only.
export const WORKSPACE_PERMISSIONS = [
  { key: 'view', label: 'View', hint: 'See files, folders, and activity' },
  { key: 'create', label: 'Create / upload', hint: 'Upload files and create folders' },
  { key: 'edit', label: 'Edit', hint: 'Edit files and content' },
  { key: 'delete', label: 'Delete', hint: 'Delete files and folders' },
  { key: 'share', label: 'Share', hint: 'Share files and create links' },
  { key: 'comment', label: 'Comment & chat', hint: 'Comment and post in chat' },
  { key: 'sign', label: 'Signatures', hint: 'Send and sign documents' },
];

export const WORKSPACE_PERMISSION_KEYS = WORKSPACE_PERMISSIONS.map((p) => p.key);

export const WORKSPACE_ROLES = [
  { value: 'admin', label: 'Admin', description: 'Full access to all workspace features' },
  { value: 'member', label: 'Member', description: 'Only the permissions you grant' },
];

export const roleLabel = (role) =>
  role === 'admin' ? 'Admin' : role === 'member' ? 'Member' : role;
